import { setCheckboxById, setInnerTextById, setInputTextByQuerySelector } from '../utils/common';
import { DOM_IDS, QUERY_SELECTORS } from '../utils/constants';
export default function loadPreferencesUI({
  maskedEmail,
  unsubscribedFromAll,
  showTrackingConsent,
  trackingConsented
}) {
  if (maskedEmail) {
    setInnerTextById(DOM_IDS.emailPlaceholder, maskedEmail);
    setInputTextByQuerySelector(QUERY_SELECTORS.modifiedEmail, maskedEmail);
    setInputTextByQuerySelector(QUERY_SELECTORS.email, maskedEmail);
  }
  if (unsubscribedFromAll) {
    setCheckboxById(DOM_IDS.unsubscribeAll, true);
  }
  if (showTrackingConsent) {
    const section = document.getElementById(DOM_IDS.trackingConsentSection);
    if (section) {
      section.style.removeProperty('display');
    }
    if (trackingConsented) {
      setCheckboxById(DOM_IDS.trackingConsentedCheckbox, true);
    }
  }
}